// Resolve a relative R2 media key to a full CDN URL. The activity payloads hold
// relative keys (see zod-schemas/content.mediaRef); the renderer needs an
// absolute URL. The CDN base is injected at the player level so the same
// renderers work in staging (staging-cdn.*) and production (cdn.*).

export function mediaUrl(cdnBase: string, key: string | null | undefined): string | null {
  if (!key) return null;
  const base = cdnBase.replace(/\/+$/, '');
  const path = key.replace(/^\/+/, '');
  return `${base}/${path}`;
}
